import nxModule from "nxModule";
import templateUrl from "./collections.template.html";

class Collections {}

nxModule.component('collections', {
  templateUrl,
  controller: Collections
});
